import dcmjs from 'dcmjs';

import pubSubServiceInterface from '../_shared/pubSubServiceInterface';
import createStudyMetadata from './createStudyMetadata';

//console.log('platform/core/src/services/DicomMetadataStore/DicomMetadataStore.ts');

const EVENTS = {
  STUDY_ADDED: 'event::dicomMetadataStore:studyAdded',
  INSTANCES_ADDED: 'event::dicomMetadataStore:instancesAdded',
  SERIES_ADDED: 'event::dicomMetadataStore:seriesAdded',
  SERIES_REMOVED: 'event::dicomMetadataStore:seriesRemoved', //?????????????
  STUDY_REMOVED: 'event::dicomMetadataStore:studyRemoved', //?????????????
  SERIES_UPDATED: 'event::dicomMetadataStore:seriesUpdated',
  INFERENCE_STARTED: 'event::dicomMetadataStore:inferenceStarted',
  INFERENCE_FINISHED: 'event::dicomMetadataStore:inferenceFinished',
  PROGRESS_VALUE_CHANGED: 'event::dicomMetadataStore:progressValueChanged',
  PROGRESS_TEXT_CHANGED: 'event::dicomMetadataStore:progressTextChanged',
};

/**
 * @example
 * studies: [
 *   {
 *     StudyInstanceUID: string,
 *     isLoaded: boolean,
 *     series: [
 *       {
 *         Modality: string,
 *         SeriesInstanceUID: string,
 *         SeriesNumber: number,
 *         SeriesDescription: string,
 *         instances: [
 *           {
 *             // naturalized instance metadata
 *             SOPInstanceUID: string,
 *             SOPClassUID: string,
 *             Rows: number,
 *             Columns: number,
 *             PatientSex: string,
 *             Modality: string,
 *             InstanceNumber: string,
 *           },
 *           {
 *             // instance 2
 *           },
 *         ],
 *       },
 *       {
 *         // series 2
 *       },
 *     ],
 *   },
 * ],
 */
const _model = {
  studies: [],
};

function _getStudyInstanceUIDs() {
  return _model.studies.map(aStudy => aStudy.StudyInstanceUID);
}

function _getSeriesInstanceUIDs(StudyInstanceUID) {
  const study = _getStudy(StudyInstanceUID);

  if (!study) {
    return;
  }
  return study.series.map(aSerie => aSerie.SeriesInstanceUID);
}

function _getStudyInferenced(StudyInstanceUID) {
  return _model.studies.find(
    aStudy => aStudy.StudyInstanceUID === StudyInstanceUID
  ).Inferenced;
}

function _getStudyInferenceInProgress(StudyInstanceUID) {
  return _model.studies.find(
    aStudy => aStudy.StudyInstanceUID === StudyInstanceUID
  ).InferenceInProgress;
}

function _getStudy(StudyInstanceUID) {
  return _model.studies.find(
    aStudy => aStudy.StudyInstanceUID === StudyInstanceUID
  );
}

function _getSeries(StudyInstanceUID, SeriesInstanceUID) {
  const study = _getStudy(StudyInstanceUID);

  if (!study) {
    return;
  }

  return study.series.find(
    aSeries => aSeries.SeriesInstanceUID === SeriesInstanceUID
  );
}

function _getInstance(StudyInstanceUID, SeriesInstanceUID, SOPInstanceUID) {
  const series = _getSeries(StudyInstanceUID, SeriesInstanceUID);

  if (!series) {
    return;
  }

  return series.instances.find(
    instance => instance.SOPInstanceUID === SOPInstanceUID
  );
}

function _getInstanceByImageId(imageId) {
  for (let study of _model.studies) {
    for (let series of study.series) {
      for (let instance of series.instances) {
        if (instance.imageId === imageId) {
          return instance;
        }
      }
    }
  }
}

function _setFileSizeToDownload(size) {
  const StudyInstanceUID = _getStudyInstanceUIDs()[0];
  // console.log('_setFileSizeToDownload study UID:', StudyInstanceUID);
  const study = _getStudy(StudyInstanceUID);

  if (!study) {
    //console.log('metadatastore no study');
    return;
  }
  study.FilesSizeToDownload = size;
  // console.log('_setFileSizeToDownload file size:', study.FilesSizeToDownload);
}

function _setDownloadedFileSize(file, size) {
  const StudyInstanceUID = _getStudyInstanceUIDs()[0];
  // console.log('_setDownloadedFileSize study UID, size:', StudyInstanceUID, size);
  const study = _getStudy(StudyInstanceUID);

  if (!study) {
    //console.log('metadatastore no study');
    return;
  }

  study.FilesSizeDownloaded[file] = size;
  // console.log('_setDownloadedFileSize file sizes:', study.FilesSizeDownloaded);

  var sizeSoFar = 0;

  for (const key of Object.keys(study.FilesSizeDownloaded)) {
    sizeSoFar += study.FilesSizeDownloaded[key];
  }
  // console.log('_setDownloadedFileSize size so far:', sizeSoFar);
  if (study.FilesSizeToDownload != undefined) {
    var progress = ((sizeSoFar / study.FilesSizeToDownload) * 100) | 0;
    DicomMetadataStore.setProgressValue(StudyInstanceUID, progress);
  }
}

function _setProgressValue(StudyInstanceUID, ProgressValue) {
  // console.log('metadatastore set progress value:', StudyInstanceUID, ProgressValue);
  const study = _getStudy(StudyInstanceUID);

  if (!study) {
    //console.log('metadatastore no study');
    return;
  }
  const old_value = study.ProgressValue;
  study.ProgressValue = ProgressValue;

  // console.log('metadatastore progress value changed to: ', study.ProgressValue);

  if (study.ProgressValue != old_value) {
    //console.log('DicomMetadataStore progress value changed event broadcast', study.ProgressValue);
    this._broadcastEvent(EVENTS.PROGRESS_VALUE_CHANGED, {
      StudyInstanceUID,
      ProgressValue,
    });
  }
}

function _updateProgressText(StudyInstanceUID, ProgressText) {
  // console.log('metadatastore updateProgressText:', StudyInstanceUID, ProgressText);
  const study = _getStudy(StudyInstanceUID);

  if (!study) {
    //console.log('metadatastore no study');
    return;
  }
  const old_value = study.ProgressText;
  study.ProgressText = ProgressText;

  // console.log('metadatastore progress text changed to / old: ', study.ProgressText, old_value);

  if (study.ProgressText != old_value) {
    //console.log('DicomMetadataStore pogress text changed event broadcast', study.ProgressText);
    this._broadcastEvent(EVENTS.PROGRESS_TEXT_CHANGED, {
      StudyInstanceUID,
      ProgressText,
    });
  }
}

function _updateInferenceInProgress(StudyInstanceUID, InferenceInProgress) {
  const study = _getStudy(StudyInstanceUID);

  if (!study) {
    return;
  }

  const old_value = study.InferenceInProgress;
  study.InferenceInProgress = InferenceInProgress;

  if (InferenceInProgress && !old_value) {
    //console.log('DicomMetadataStore inference started event broadcast');
    this._broadcastEvent(EVENTS.INFERENCE_STARTED, {
      StudyInstanceUID,
      InferenceInProgress,
    });
  }
}

function _updateInferenced(StudyInstanceUID, Inferenced, error) {
  const study = _getStudy(StudyInstanceUID);

  if (!study) {
    return;
  }

  const old_value = study.Inferenced;
  study.Inferenced = Inferenced;

  study.error = error;

  if ((Inferenced && !old_value) || error) {
    //console.log('DicomMetadataStore inference finished event broadcast');
    this._broadcastEvent(EVENTS.INFERENCE_FINISHED, {
      StudyInstanceUID,
      Inferenced,
      error,
    });
  }
}

/**
 * Update the metadata of a specific series
 * @param {*} StudyInstanceUID
 * @param {*} SeriesInstanceUID
 * @param {*} metadata metadata inform of key value pairs
 * @returns
 */
function _updateMetadataForSeries(
  StudyInstanceUID,
  SeriesInstanceUID,
  metadata
) {
  const study = _getStudy(StudyInstanceUID);

  if (!study) {
    return;
  }

  const series = study.series.find(
    aSeries => aSeries.SeriesInstanceUID === SeriesInstanceUID
  );

  const { instances } = series;
  // update all instances metadata for this series with the new metadata
  instances.forEach(instance => {
    Object.keys(metadata).forEach(key => {
      // if metadata[key] is an object, we need to merge it with the existing
      // metadata of the instance
      if (typeof metadata[key] === 'object') {
        instance[key] = { ...instance[key], ...metadata[key] };
      }
      // otherwise, we just replace the existing metadata with the new one
      else {
        instance[key] = metadata[key];
      }
    });
  });

  // broadcast the series updated event
  this._broadcastEvent(EVENTS.SERIES_UPDATED, {
    SeriesInstanceUID,
    StudyInstanceUID,
    madeInClient: true,
  });
}

const BaseImplementation = {
  EVENTS,
  listeners: {},

  init() {
    _model.studies = [];
  },

  addInstance(dicomJSONDatasetOrP10ArrayBuffer) {
    //console.log('DicomMetadataStore addinstance');
    let dicomJSONDataset;

    // If Arraybuffer, parse to DICOMJSON before naturalizing.
    if (dicomJSONDatasetOrP10ArrayBuffer instanceof ArrayBuffer) {
      const dicomData = dcmjs.data.DicomMessage.readFile(
        dicomJSONDatasetOrP10ArrayBuffer
      );

      dicomJSONDataset = dicomData.dict;
    } else {
      dicomJSONDataset = dicomJSONDatasetOrP10ArrayBuffer;
    }

    let naturalizedDataset;

    if (dicomJSONDataset['SeriesInstanceUID'] === undefined) {
      naturalizedDataset = dcmjs.data.DicomMetaDictionary.naturalizeDataset(
        dicomJSONDataset
      );
    } else {
      naturalizedDataset = dicomJSONDataset;
    }

    const { StudyInstanceUID } = naturalizedDataset;

    let study = _model.studies.find(
      study => study.StudyInstanceUID === StudyInstanceUID
    );

    if (!study) {
      _model.studies.push(createStudyMetadata(StudyInstanceUID));
      study = _model.studies[_model.studies.length - 1];
    }

    study.addInstanceToSeries(naturalizedDataset);
  },

  addInstances(instances, madeInClient = false) {
    //console.log('DicomMetadataStore addInstances');

    const { StudyInstanceUID, SeriesInstanceUID } = instances[0];

    let study = _model.studies.find(
      study => study.StudyInstanceUID === StudyInstanceUID
    );

    if (!study) {
      _model.studies.push(createStudyMetadata(StudyInstanceUID));

      study = _model.studies[_model.studies.length - 1];
    }

    study.addInstancesToSeries(instances);

    // Broadcast an event even if we used cached data.
    // This is because the mode needs to listen to instances that are added to build up its active displaySets.
    // It will see there are cached displaySets and end early if this Series has already been fired in this
    // Mode session for some reason.

    // console.log('addInstancesToSeries broadcast for serie', SeriesInstanceUID);

    this._broadcastEvent(EVENTS.INSTANCES_ADDED, {
      StudyInstanceUID,
      SeriesInstanceUID,
      madeInClient,
    });
  },

  triggerInstancesAdded(madeInClient) {
    //console.log('DicomMetadataStore triggerInstancesAdded');

    const StudyInstanceUID = DicomMetadataStore.getStudyInstanceUIDs()[0];
    // console.log('triggerInstancesAdded study uid', StudyInstanceUID);

    const SeriesInstanceUIDs = DicomMetadataStore.getSeriesInstanceUIDs(
      StudyInstanceUID
    );
    // console.log('triggerInstancesAdded series uids', SeriesInstanceUIDs);
    SeriesInstanceUIDs.sort();

    for (let index = SeriesInstanceUIDs.length - 1; index >= 0; index--) {
      const SeriesInstanceUID = SeriesInstanceUIDs[index];

      this._broadcastEvent(EVENTS.INSTANCES_ADDED, {
        StudyInstanceUID,
        SeriesInstanceUID,
        madeInClient,
      });
    }
  },

  removeSeries(StudyInstanceUID, SeriesInstanceUID, madeInClient = false) {
    //console.log('DicomMetadataStore removeSeries', StudyInstanceUID, SeriesInstanceUID);
    let study = _model.studies.find(
      study => study.StudyInstanceUID === StudyInstanceUID
    );
    if (!study) {
      return;
    }

    //console.log('DicomMetadataStore remove from study', study);

    let newSeries = study.series.filter(
      aSeries => aSeries.SeriesInstanceUID != SeriesInstanceUID
    );

    //console.log('DicomMetadataStore newseries', newSeries);

    study.series = newSeries;

    //console.log('DicomMetadataStore new study', study);

    this._broadcastEvent(EVENTS.SERIES_REMOVED, {
      StudyInstanceUID,
      madeInClient,
    });
  },
  removeStudy(StudyInstanceUID, madeInClient = false) {
    //console.log('DicomMetadataStore removeStudy', StudyInstanceUID);
    // console.log('DicomMetadataStore before:', _model.studies);

    let studies = _model.studies.filter(
      aStudy => aStudy.StudyInstanceUID != StudyInstanceUID
    );

    // console.log('DicomMetadataStore filtered studies', studies);

    _model.studies = studies;
    // addSeriesMetadata ??????????????
    // console.log('DicomMetadataStore after:', _model.studies);

    this._broadcastEvent(EVENTS.STUDY_REMOVED, {
      StudyInstanceUID,
      madeInClient,
    });
  },
  addSeriesMetadata(seriesSummaryMetadata, madeInClient = false) {
    //console.log('DicomMetadataStore addSeriesMetadata');
    const { StudyInstanceUID } = seriesSummaryMetadata[0];
    let study = _getStudy(StudyInstanceUID);
    if (!study) {
      study = createStudyMetadata(StudyInstanceUID);
      // Will typically be undefined with a compliant DICOMweb server, reset later
      study.StudyDescription = seriesSummaryMetadata[0].StudyDescription;
      seriesSummaryMetadata.forEach(item => {
        if (study.ModalitiesInStudy.indexOf(item.Modality) === -1) {
          study.ModalitiesInStudy.push(item.Modality);
        }
      });
      study.NumberOfStudyRelatedSeries = seriesSummaryMetadata.length;
      _model.studies.push(study);
    }

    seriesSummaryMetadata.forEach(series => {
      const { SeriesInstanceUID } = series;

      study.setSeriesMetadata(SeriesInstanceUID, series);
    });

    this._broadcastEvent(EVENTS.SERIES_ADDED, {
      StudyInstanceUID,
      madeInClient,
    });
  },
  addStudy(study) {
    //console.log('DicomMetadataStore addStudy');
    const { StudyInstanceUID } = study;

    let existingStudy = _model.studies.find(
      study => study.StudyInstanceUID === StudyInstanceUID
    );

    if (!existingStudy) {
      const newStudy = createStudyMetadata(StudyInstanceUID);

      newStudy.PatientID = study.PatientID;
      newStudy.PatientName = study.PatientName;
      newStudy.StudyDate = study.StudyDate;
      newStudy.ModalitiesInStudy = study.ModalitiesInStudy;
      newStudy.StudyDescription = study.StudyDescription;
      newStudy.AccessionNumber = study.AccessionNumber;
      newStudy.NumInstances = study.NumInstances; // todo: Correct naming?

      _model.studies.push(newStudy);
    }
  },
  getStudyInstanceUIDs: _getStudyInstanceUIDs,
  getStudy: _getStudy,
  getSeries: _getSeries,
  getSeriesInstanceUIDs: _getSeriesInstanceUIDs,
  getInstance: _getInstance,
  getInstanceByImageId: _getInstanceByImageId,
  updateMetadataForSeries: _updateMetadataForSeries,
  updateInferenceInProgress: _updateInferenceInProgress,
  updateInferenced: _updateInferenced,
  getStudyInferenced: _getStudyInferenced,
  getStudyInferenceInProgress: _getStudyInferenceInProgress,
  setProgressValue: _setProgressValue,
  updateProgressText: _updateProgressText,
  setDownloadedFileSize: _setDownloadedFileSize,
  setFileSizeToDownload: _setFileSizeToDownload,
};
const DicomMetadataStore = Object.assign(
  // get study

  // iterate over all series

  {},
  BaseImplementation,
  pubSubServiceInterface
);

export { DicomMetadataStore };
export default DicomMetadataStore;
